export function isEmptyString(value: string | null | undefined): value is null | undefined | '' {
  return value == null || value.trim() === '';
}

/**
 * Case-insensitive string includes check
 * Similar to ~/code/ui/app/utils/string.ts stringIncludes
 */
export function stringIncludes(haystack: string, needle: string, caseSensitive = false): boolean {
  const haystackStr = (haystack !== '' && haystack != null ? haystack : '').toString();
  const needleStr = (needle !== '' && needle != null ? needle : '').toString();

  if (!caseSensitive) {
    return haystackStr.toLowerCase().includes(needleStr.toLowerCase());
  }

  return haystackStr.includes(needleStr);
}
